import GeneralError from '../../components/GeneralError';
import Main from '../../frame/main/Main';

const SchoolHasNotJoinedEvent = () => {
    return (
        <Main>
            <GeneralError error="Vi finner ikke at skolen er påmeldt OD 2022. Er dette en feil? Prøv igjen eller kontakt oss med chatteboblen nede til høyre." />
        </Main>
    );
};

export default SchoolHasNotJoinedEvent;
